import 'large-small-dynamic-viewport-units-polyfill'
import 'semantic-ui-css/semantic.min.css'
import 'unfonts.css'
import './index.css'
import './semantic.overrides.css'

import { render } from 'preact'
import { App } from './app'
import { ErrorBoundary, Provider, TrackerProvider } from './store'
import AppStore from './store/AppStore'
// import 'preact/debug'

const store = new AppStore()

render(
  <ErrorBoundary>
    <TrackerProvider ga={window.ga}>
      <Provider store={store}>
        <div id="data-capture-view"></div>
        <App />
      </Provider>
    </TrackerProvider>
  </ErrorBoundary>,
  document.getElementById('app') as HTMLElement
)
